import { Container, Nav, Navbar, NavDropdown, NavItem } from 'react-bootstrap';
import { NavLink, useNavigate } from 'react-router-dom';
import Logo from '../../../assets/Images/Lei_de_TICS.png';
import { useCompany } from '../../../hooks/useCompany';
import { useOAuthUser } from '../../../hooks/useOAuthUser';
import './styles.css';
import { useCan } from '../../../hooks/useCan';
import { useAuth } from "oidc-react";
import { BiExit } from 'react-icons/bi';

const NavbarHome = () => {
    const navigate = useNavigate();
    const user = useOAuthUser();
    const { company } = useCompany();
    const auth = useAuth();

    const Logout = () => {
        auth.signOutRedirect(auth.userManager.settings.authority?.toString())
    }
    const LogoutCompany = () => {
        navigate("/Login");
    }
    const permissionTechnician = useCan({ rolesCan: ["Technician"] });
    const permissionTransformer = useCan({ rolesCan: ["Transformer","Administrator","Consultant","Internal","Trainee"] });
    const canNotViewTechnicalIdentification = useCan({ rolesCan: ["HumanResources", "TechnicianLimited", "Dossie", "Financial"] });

    return (
        <Navbar collapseOnSelect expand="lg" className='back-white p-0'>
            <Container fluid className='pe-0'>
                <Navbar.Brand className='p-0 margin-navbar' href={`/${company.serviceId}/home`}>
                    <img src={Logo} alt="logo" />
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                <Navbar.Collapse className='justify-content-between h-100 d-flex' id="responsive-navbar-nav">
                    <Nav className="me-auto align-items-center justify-content-between">
                        <NavItem className='p-0 margin-navbar'>
                            <NavLink to={`/${company.serviceId}/home`}>Homepage</NavLink>
                        </NavItem>
                        <NavDropdown
                            title={
                                <span>
                                    I. Produtos
                                </span>
                            }
                            id="navbarScrollingNavDropdown"
                            className='p-0 margin-navbar'
                        >
                            <NavDropdown.Item
                                as={NavLink}
                                to={`/${company.serviceId}/${company.companyId}/products`}
                            >
                                I.1. Produtos e Modelos
                            </NavDropdown.Item>
                            <NavDropdown.Item className=' cursor-not-allowed' id='ppb'>
                                <p className='p-0  margin-navbar' id='ppb' style={{ fontWeight: 'bold' }}>I.2 PPB (Em Breve)</p>
                            </NavDropdown.Item>
                        </NavDropdown>
                        {permissionTechnician ?
                            <div>
                            </div> :
                            company.region && company.region === "SUFRAMA" || company.branchRegionHasSuframa && company.branchRegionHasSuframa === true ?
                                <NavDropdown
                                    title={
                                        <span>
                                            II. Faturamentos e Aquisições
                                        </span>
                                    }
                                    id="navbarScrollingNavDropdown"
                                    className='p-0 margin-navbar'
                                ><NavDropdown.Item
                                    as={NavLink}
                                    to={`/${company.serviceId}/${company.companyId}/invoicing`}
                                >
                                        II.1. Faturamentos
                                    </NavDropdown.Item><NavDropdown.Item
                                        as={NavLink}
                                        to={`/${company.serviceId}/${company.companyId}/acquisitions`}
                                    >
                                        II.2. Aquisições
                                    </NavDropdown.Item></NavDropdown>
                                : permissionTechnician ?
                                    <NavItem></NavItem> :
                                    <NavItem className='p-0 margin-navbar'><NavLink to={`/${company.serviceId}/${company.companyId}/invoicing`}>II. Faturamento</NavLink></NavItem>
                        }

                        {!canNotViewTechnicalIdentification &&
                            <NavDropdown title={
                                <span>
                                    III. Identificação Técnica
                                </span>
                            }
                                id="navbarScrollingNavDropdown"
                                className='p-0 margin-navbar'
                            >
                                <NavDropdown.Item
                                    as={NavLink}
                                    to={`/${company.serviceId}/internalProjects`}>
                                    <p className='p-0 m-0'>III.1. Projetos Internos</p>

                                </NavDropdown.Item>
                                <NavDropdown.Item className=' cursor-not-allowed' id='ppb'>
                                    <p className='p-0  margin-navbar' id='ppb' style={{ fontWeight: 'bold' }}>III.2 Projetos Externos (Em Breve)</p>
                                </NavDropdown.Item>
                                <NavDropdown.Item
                                    as={NavLink}
                                    to={`/${company.serviceId}/macroSteps`}>
                                    <p className='p-0 m-0'>III.3. Macro Etapas</p>

                                </NavDropdown.Item>
                            </NavDropdown>
                        }

                        {permissionTransformer && (
                            <NavDropdown
                                title={
                                    <span>
                                        IV. Dispêndios
                                    </span>
                                }
                                id="navbarScrollingNavDropdown"
                                className='p-0 margin-navbar'
                            >
                                <NavDropdown.Item as={NavLink}
                                    to={`/${company.serviceId}/summaryOfValues`}>
                                    <p className='p-0 m-0'>IV.0. Resumo de Valores</p>
                                </NavDropdown.Item>
                                <NavDropdown.Item as={NavLink}
                                    to={`/${company.serviceId}/expenditure`}>
                                    <p className='p-0 m-0'>IV.1. Dispêndios</p>
                                </NavDropdown.Item>
                                <NavDropdown.Item as={NavLink}
                                    to={`/${company.serviceId}/staffs`}>
                                    <p className='p-0 m-0'>IV.2. Cadastro de Funcionários</p>
                                </NavDropdown.Item>
                                <NavDropdown.Item as={NavLink}
                                    to={`/${company.serviceId}/pointHours`}>
                                    <p className='p-0 m-0'>IV.3. Apontamento de Horas</p>
                                </NavDropdown.Item>
                            </NavDropdown>
                        )}

                        {!permissionTechnician &&
                            <>

                                {/*<NavItem className='p-0 inav margin-navbar'>
                                    III. Identificação Técnica
                                    <p className='breve'>  (Em Breve)</p>
                                </NavItem>*/}
                                <NavItem className='p-0 margin-navbar'>
                                    <NavLink to={`/${company.serviceId}/credit`}>V. Crédito Financeiro</NavLink>
                                </NavItem>
                                <NavItem className='p-0 inav margin-navbar'>
                                    VI. RDA
                                    <p className='breve'>  (Em Breve) </p>
                                </NavItem>
                            </>
                        }
                    </Nav>

                    <div className='polygon-rectangle-wrap'>
                        <div className='polygon-rectangle'>
                            <Nav className='last-child'>
                                <NavDropdown
                                    title={
                                        <span>Olá, {user?.profile.given_name}</span>
                                    }
                                    id="navbarScrollingNavDropdown"
                                >
                                    {/* <NavDropdown.Item
                                        as={NavLink}
                                        to={`/managment`}
                                    >
                                        Painel de Controle
                                    </NavDropdown.Item> */}
                                    <NavDropdown.Item
                                        as={NavLink}
                                        to={`/true`}
                                    >
                                        Gestão de Ano Fiscal
                                    </NavDropdown.Item>
                                    <NavDropdown.Item
                                        as={NavLink}
                                        to={`/${company.serviceId}/fileManager`}
                                    >
                                        Gerenciador de Documentos
                                    </NavDropdown.Item>
                                    <NavDropdown.Item
                                        as={NavLink}
                                        to={`/${company.serviceId}/Logs`}
                                    >
                                        Logs
                                    </NavDropdown.Item>
                                </NavDropdown>
                                <NavDropdown
                                    title={
                                        <BiExit size={20} className='cursor-pointer me-1' />

                                    }
                                    className="d-flex align-items-center"
                                    id="navbarScrollingNavDropdown"
                                >

                                    <NavDropdown.Item
                                        onClick={() => LogoutCompany()}
                                    >
                                        Seleção de empresas
                                    </NavDropdown.Item>

                                    <NavDropdown.Item
                                        onClick={() => Logout()}
                                    >
                                        Sair
                                    </NavDropdown.Item>
                                </NavDropdown>
                                <div className="d-flex align-items-center">
                                </div>
                            </Nav>
                        </div>
                    </div>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    )
}

export default NavbarHome;
